import jump from './util/jump';

// declarative DOM interface
let triggers = document.querySelectorAll('[data-jump]');

triggers.forEach( el => {
  let target = el.dataset.jumpTarget || +el.dataset.jumpDistance;
  let duration = el.dataset.jumpDuration;
  let offset = +el.dataset.jumpOffset;

  let opts = { duration, offset };

  el.addEventListener( 'click', e => {
    e.preventDefault();
    jump( target, opts );
  });
});

// check avail links
let checkAvailLinks = document.querySelectorAll('.js-scroll-check-avail');

if ( checkAvailLinks ) {
  checkAvailLinks.forEach( link => {
    link.addEventListener( 'click', e => {
      e.preventDefault();
      jump('#check-availability');
    });
  });
}

//contact us links
let contactUsLinks = document.querySelectorAll('.js-scroll-contact-us');

if ( contactUsLinks ) {
  contactUsLinks.forEach( link => {
    link.addEventListener( 'click', e => {
      e.preventDefault();
      jump('#contact-us');
    });
  });
}


export default undefined;
